/**!
 * @author Steve Piron <https://twitter.com/stevepiron>
 * @requires jQuery
 *
 * A jQuery plugin turning simple links to an image into a lightbox containing
 * that image.
 */
(function() {

    var defaults;
    var params;

    var $window = $(window);
    var $document = $(document);
    var $lightbox;
    var $lightboxValign;
    var $lightboxImg;
    var dpr = window.devicePixelRatio;
    var originalWidth = 0;
    var maxWidth = 0;
    var _window_width = 0;
    var _window_height = 0;
    var $links = undefined;
    var linksIndex = undefined;
    var $prevArrow = undefined;
    var $nextArrow = undefined;
    var lightboxPrevEvent = new window.CustomEvent('lightboxPrev');
    var lightboxNextEvent = new window.CustomEvent('lightboxNext');

    // ====================================================================== //
    // Functions
    // ====================================================================== //

    /**
     * @function `elementClass`
     *
     * A helper function to build the BEM class names.
     *
     * @param element {string} - the E in B__E--M.
     * @param obj {obj} - the object from which to get the block class.
     */
    function elementClass( element, obj, jsClass ) {
        if( typeof obj == 'undefined' ) {
            obj = params;
        }
        if( typeof jsClass == 'undefined' ) {
            jsClass = false;
        }
        if( !element.length || !obj.cssClasses.length ) {
            return;
        }
        var block = jsClass ? obj.jsClass : obj.cssClasses[0];
        return block+'__'+element;
    }

    /**
     * @function `elementClasses`
     *
     * Returns a string of classes made of both the regular CSS class and the
     * JS class.
     */
    function elementClasses( element ) {
        if( !element.length ) {
            return;
        }
        var classes = [];
        classes.push(params.cssClasses[0] + '__' + element);
        classes.push(params.jsClass + '__' + element);
        return classes.join(' ');
    }

    /**
     * @function `createLightbox`
     *
     * Creates an empty lightbox and appends it to container defined
     * as parameter.
     */
    function createLightbox() {
        if( $document.find('.'+params.jsClass).length ) {
            return;
        }
        var lightboxHtml = '<div class="'+params.cssClasses.join(' ')+' '+
            params.jsClass+'" tabindex="-1">';
        lightboxHtml += params.closeHtml;
        lightboxHtml += params.prevHtml;
        lightboxHtml += params.nextHtml;
        lightboxHtml += params.loaderHtml;
        lightboxHtml += '<div class="'+elementClasses(params.contentContainer)+'">';
        lightboxHtml += '<div class="'+elementClasses(params.valign)+'">';
        var imgHtml = '<img class="'+elementClasses(params.img)+'" src="">';
        lightboxHtml += imgHtml;
        lightboxHtml += '</div>';
        lightboxHtml += '</div>';
        lightboxHtml += '</div>';
        $lightbox = $(lightboxHtml);
        $(params.appendTo).append($lightbox);
        $lightboxValign = $lightbox
            .find('.'+elementClass(params.valign, params, true)).eq(0);
        $lightboxImg = $lightbox.find('img').eq(0);
        $prevArrow = $lightbox.find('.'+params.jsClass+'__'+params.prev);
        $nextArrow = $lightbox.find('.'+params.jsClass+'__'+params.next);
    }

    /**
     * @function `setImage`
     *
     * Loads the high-res version of the image in the lightbox.
     */
    function setImage( $link ) {
        var src = $link.attr('href');
        setTimeout(function () {
            $lightboxImg.attr('src', src);
            var $img = $link.find('img');
            if( params.srcset ) {
                var srcset = $img.attr('srcset');
                $lightboxImg.attr('srcset', srcset);
                $lightboxImg.attr('sizes', 100 * params.imgToViewportRatio + 'vw');
            }
            if( params.keepImageSharp ) {
                originalWidth = $link.data(params.dataOriginalWidth);
                maxWidth = originalWidth / dpr;
                // $lightboxImg
                //     .attr('data-original-width', originalWidth)
                //     .attr('data-max-width', maxWidth );
            }
            var desiredWidth = $window.outerWidth() * params.imgToViewportRatio;
            var width = (desiredWidth <= maxWidth) ? desiredWidth : maxWidth;
            $lightboxImg
                .attr('width', width);
        }, params.transitionDuration);
    }

    /**
     * @function `arrowState`
     *
     * Changes the state of the arrow based on the image currently displayed.
     */
    function arrowsState () {
        if (linksIndex === 0) {
            $prevArrow.addClass('is-disabled');
        } else if (linksIndex === $links.length - 1) {
            $nextArrow.addClass('is-disabled');
        } else {
            $prevArrow.removeClass('is-disabled');
            $nextArrow.removeClass('is-disabled');
        }
    }

    /**
     * @function `showLightbox`
     *
     * Shows the lightbox when clicking on an image.
     */
    function showLightbox( $link ) {
        if( typeof params.onBeforeOpen == 'function' ) {
            params.onBeforeOpen();
        }
        setImage($link);
        arrowsState();
        $lightbox.addClass(params.visibleClass);
        $lightbox.focus();
    }

    /**
     * @function `hideLightbox`
     *
     * Hides the lightbox without removing it from the DOM, by doing the
     * opposite of `showLightbox`.
     */
    function hideLightbox() {
        $lightbox.removeClass(params.visibleClass);
        if( typeof params.onAfterClose == 'function' ) {
            params.onAfterClose();
        }
    }

    /**
     * @function `calcWindowDimensions`
     *
     * Saves window width and height.
     */
    function calcWindowDimensions() {
        _window_width = $window.outerWidth();
        _window_height = $window.outerHeight();
    }

    /**
     * @function `centerImage`
     *
     * Programmatically scrolls the lightbox so that the image is centered.
     */
    function centerImage() {
        var imageHeight = $lightboxImg.outerHeight();
        var imageWidth = $lightboxImg.outerWidth();
        $lightbox
            .scrollTop( Math.abs((imageHeight - _window_height)/2) )
            .scrollLeft( Math.abs((imageWidth - _window_width)/2) );
    }

    /**
     * @function `loadingFeedback`
     *
     * Adds a class to make the loader visible.
     */
    function loadingFeedback() {
        $lightbox.addClass(params.loadingClass);
    }

    /**
     * @function `removeLoadingFeedback`
     *
     * Removes the class that makes the loader visible.
     */
    function removeLoadingFeedback() {
        $lightbox.removeClass(params.loadingClass);
    }

    // ====================================================================== //
    // Plugin
    // ====================================================================== //

    $.fn.spLightbox = function( options ) {

        /**
         * Note: using `return` keeps jQuery's chaining possibility
         */
        return this.each(function(i, inst) {

            var $this = $(inst);

            defaults = new function() {
                this.jsClass = 'js-lightbox',
                this.cssClasses = ['c-lightbox'],
                this.links = '.js-lightbox-trigger',
                this.closeLabel = $this.data('close') || 'Close',
                this.close = 'close',
                this.closeHtml = '<button class="'+elementClass(this.close, this)+
                    ' ' +elementClass(this.close, this, true)+'">'+
                    this.closeLabel+'</button>',
                this.prevLabel = $this.data('prev') || 'Previous',
                this.prev = 'prev',
                this.prevHtml = '<button class="'+elementClass('arrow', this)+' '+elementClass(this.prev, this)+' '+elementClass(this.prev, this, true)+'">'+this.prevLabel+'</button>',
                this.nextLabel = $this.data('next') || 'Next',
                this.next = 'next',
                this.nextHtml = '<button class="'+elementClass('arrow', this)+' '+elementClass(this.next, this)+' '+elementClass(this.next, this, true)+'">'+this.nextLabel+'</button>',
                this.loadingClass = 'is-loading',
                this.loader = 'loader',
                this.loaderHtml = '<div class="'+elementClass(this.loader, this)+'"></div>',
                this.img = 'img',
                this.appendTo = 'body',
                this.visibleClass = 'is-visible',
                this.contentContainer = 'content',
                this.valign = 'valign',
                this.onBeforeOpen = null,
                this.onAfterClose = null,
                this.srcset = false,
                this.imgToViewportRatio = 2,
                this.keepImageSharp = true,
                this.dataOriginalWidth = 'original-width',
                this.transitionDuration = 300
            };

            params = $.extend( defaults, options );

            $links = $(params.links);

            createLightbox();

            // ============================================================== //
            // On ready
            // ============================================================== //

            $document.ready(function() {
                calcWindowDimensions();
            });

            // ============================================================== //
            // On click
            // ============================================================== //

            $document.on('click', params.links, function(e) {
                var $link = $(this);
                e.preventDefault();
                linksIndex = $links.index($link);
                loadingFeedback();
                showLightbox($link);
            });

            // ============================================================== //
            // On image load
            // ============================================================== //

            $lightboxImg.on('load', function() {
                centerImage();
                removeLoadingFeedback();
            });

            // ============================================================== //
            // Prev/next
            // ============================================================== //

            $document.on('click', '.'+params.jsClass+'__'+params.prev, function(e) {
                if (linksIndex === 0) {
                    return;
                }
                linksIndex--;
                loadingFeedback();
                setImage($links.eq(linksIndex));
                window.dispatchEvent(lightboxPrevEvent);
                arrowsState();
            });

            $document.on('click', '.'+params.jsClass+'__'+params.next, function(e) {
                if (linksIndex === $links.length) {
                    return;
                }
                linksIndex++;
                loadingFeedback();
                setImage($links.eq(linksIndex));
                window.dispatchEvent(lightboxNextEvent);
                arrowsState();
            });

            // ============================================================== //
            // Closing
            // ============================================================== //

            $document.on('click', '.'+params.jsClass+'__'+params.close, function() {
                hideLightbox();
            });

            // ============================================================== //
            // On resize
            // ============================================================== //

            $window.on('resize', function() {
                calcWindowDimensions();
                if( !$lightbox.hasClass(params.visibleClass) ) {
                    return;
                }
                var desiredWidth = $window.outerWidth()
                    * params.imgToViewportRatio;
                if( params.keepImageSharp ) {
                    if( desiredWidth <= maxWidth ) {
                        $lightboxImg.attr('width', desiredWidth);
                    }
                    else {
                        $lightboxImg.attr('width', maxWidth);
                    }
                }
                else {
                    $lightboxImg.attr('width', desiredWidth);
                }
            });

        });
    };

})( jQuery );
